import { AppRoute } from '@agentselly/immodossier-shared';
import { marketWidgets } from '~/config/widgets/marketWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_DOSSIER_MARKET,
  marketWidgets,
  true,
);
